import api from './api'

/**
 * Scheduled Task Service
 * Manages recurring analysis tasks with Stripe subscriptions
 */
class ScheduledTaskService {
  /**
   * Create a new scheduled task
   */
  async createScheduledTask(taskData) {
    const payload = {
      ticker: taskData.ticker,
      scheduleType: taskData.scheduleType,
      scheduleDayOfWeek: taskData.scheduleDayOfWeek,
      scheduleDayOfMonth: taskData.scheduleDayOfMonth,
      scheduleHour: taskData.scheduleHour,
      scheduleMinute: taskData.scheduleMinute,
      notificationEmail: taskData.notificationEmail,
      selectedAnalysts: taskData.selectedAnalysts,
      researchDepth: taskData.researchDepth,
      paymentMethodId: taskData.paymentMethodId,
    }
    const response = await api.post('/api/v1/scheduled-tasks', payload)
    return response.data
  }

  /**
   * Estimate subscription cost before creating (v2.0)
   */
  async estimateSubscription(params) {
    const payload = {
      ticker: params.ticker || 'AAPL',
      scheduleType: params.scheduleType,
      scheduleDayOfWeek: params.scheduleDayOfWeek,
      selectedAnalysts: params.selectedAnalysts,
      researchDepth: params.researchDepth,
    }
    const response = await api.post('/api/v1/scheduled-tasks/estimate', payload)
    return response.data
  }

  /**
   * Get scheduled tasks list for current user
   */
  async getScheduledTasks(params = {}) {
    const { page = 0, pageSize = 12, status, ticker } = params
    const queryParams = {
      page,
      pageSize,
      ...(status !== undefined && { status }),
      ...(ticker !== undefined && { ticker }),
    }
    const response = await api.get('/api/v1/scheduled-tasks', { params: queryParams })
    return response.data
  }

  /**
   * Cancel a scheduled task (unsubscribe — cancel at period end)
   */
  async cancelScheduledTask(taskId) {
    const response = await api.delete(`/api/v1/scheduled-tasks/${taskId}`)
    return response.data
  }

  /**
   * Get scheduled task statistics
   */
  async getStats() {
    try {
      const response = await api.get('/api/v1/scheduled-tasks/stats/summary')
      return response.data
    } catch (error) {
      console.error('Error fetching scheduled task stats:', error)
      return {
        total: 0,
        active: 0,
        paused: 0,
        pendingPayment: 0,
        paymentFailed: 0,
        canceled: 0,
      }
    }
  }
}

export default new ScheduledTaskService()
